(function($) {

    var mainClass = '.webinar-tabs';
    var container = $(mainClass),
        tabs = container.find(mainClass + '__tab');

    var items = {
        presentation: $('.webinar-details__presentation'),
        faq: $('.webinar-details__faq'),
        files: $('.webinar-details__files')
    };

    var activeClass = (mainClass + '__tab--active').substring(1);


    var mod = {

        init: function() {
            var self = this;
            if(!container.size()) return;

            tabs.click(function() {

                for(var i in items) {
                    items[i].hide();
                }
                tabs.removeClass(activeClass);
                $(this).addClass(activeClass);

                $('.webinar-details__' + $(this).data('tab')).show();
            })
        }

    };

    $(document).ready(function() {
        mod.init();
    });

})(jQuery);
